import UntypedPanel from './Panel';

export default UntypedPanel as any;
